// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

// Distinct from common/models/user, which is for non-self/API user models
class SelfUserRecord extends Immutable.Record({
  'access_granted_at': String(),
  ambassadorSsoUrl: String(), // Only populated by user-settings-controller actions!
  bio: null,
  birthday: null,
  category: String(),
  'created_at': String(),
  'display_name': String(),
  email: String(),
  experiments: Immutable.Map(),
  gender: String(),
  id: null,
  isVerifiedCurator: Boolean(),
  loggedIn: Boolean(),
  'photo_url': String(),
  providers: Immutable.Map(),
  'provider_info': Immutable.List(),
  referralToken: String(),
  rollouts: Immutable.Map(),
  'signup_context': String(),
  'user_type': String(),
  username: String(),
  /*
   * These fields are web-app only and do not exist in the server-side user-model!
   * @see the `gatherCommonState` function in `client-v2/common/server.js`
   */
  sharesUnreadCount: Number(0),
  sharesUnreadCountState: FetchStateEnum.EMPTY
}) {

  hasRollout(key) {
    // Bots don't get rollouts
    if (Immutable.Map.isMap(this.rollouts)) {
      return Boolean(this.rollouts.get(key))
    }
    return false
  }

  getExperiment(key) {
    // Bots don't get experiments
    if (Immutable.Map.isMap(this.experiments)) {
      return this.experiments.get(key)
    }
  }

}

SelfUserRecord.reviver = keyedReviver(SelfUserRecord, {
  experiments: defaultReviver,
  providers: defaultReviver,
  'provider_info': defaultReviver,
  rollouts: defaultReviver
})

if (__DEV__ ) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  SelfUserRecord.propTypes = {
    'access_granted_at': PropTypes.string,
    ambassadorSsoUrl: PropTypes.string,
    bio: PropTypes.string,
    birthday: PropTypes.number,
    category: PropTypes.string,
    'created_at': PropTypes.string,
    'display_name': PropTypes.string,
    email: PropTypes.string,
    experiments: PropTypes.object,
    gender: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isVerifiedCurator: PropTypes.bool,
    loggedIn: PropTypes.bool,
    'photo_url': PropTypes.string,
    providers: PropTypes.object,
    'provider_info': PropTypes.array,
    referralToken: PropTypes.string,
    rollouts: PropTypes.object,
    'signup_context': PropTypes.string,
    'user_type': PropTypes.string,
    username: PropTypes.string
  }
}

module.exports = SelfUserRecord
